// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609160204/js/" + chunkId + "." + {"44":"e07c53ac","225":"62b6610d","481":"2fd84ae4","486":"0bf82628","770":"e184e804"}[chunkId] + ".0.02275727232028424.chunk.js";
};